import React, { Component } from 'react';
import PropTypes from 'prop-types';
import syllable from 'syllable';
import styles from './HaikuLine.css';

class HaikuLine extends Component {

  state = {
    line_count: 0,
    line: ""
  }

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
  }

  updateCount = (e) => {
    this.setState( {line: e.target.value, line_count: syllable(e.target.value) } );
  }

  render() {

        //  <img src="../img/{ this.state.line_count }_{ this.props.syllable_count }.png">
    if (this.state.line_count == this.props.syllable_count) {
      var class_type = "match";
    } else {
      var class_type = "nomatch";
    }

    if (this.state.line_count < this.props.syllable_count) {
      var imgPath = "/img/" + this.state.line_count + "_" + this.props.syllable_count + ".png" ;
    } else {
      var imgPath = "/img/" + this.props.syllable_count + "_" + this.props.syllable_count + ".png";
    }

    return (
      <div className="HaikuLine">
          <input type="text" class={class_type} onChange={this.updateCount}></input> 
          <img class="dotimg" src={process.env.PUBLIC_URL + imgPath } />
      </div>
    );
  }
}

export default HaikuLine;
